import type { TRule } from '@ballerine/common';

import { getRuleEngineRunner } from '../../rule-engine.repository';

export const executeRule = (context: object, rule: TRule) => {
  const runEngine = getRuleEngineRunner(rule.engine);

  return runEngine(context, rule);
};
